import { ChevronLeft, ChevronRight } from 'lucide-react'
import Button from '@/components/ui/Button'
import type { Paginated } from '@/types'

/** Prev / next pager for Laravel-paginated lists. Hidden while everything fits on one page. */
export default function Pager({
  meta,
  page,
  onPage,
}: {
  meta?: Paginated<unknown>['meta']
  page: number
  onPage: (page: number) => void
}) {
  if (!meta || meta.last_page <= 1) return null

  return (
    <div className="mt-4 flex items-center justify-between gap-2">
      <Button variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        <ChevronLeft className="size-4" /> Prev
      </Button>
      <span className="text-sm text-muted">
        <span className="hidden sm:inline">Page </span>
        {meta.current_page}
        <span className="sm:hidden"> / </span>
        <span className="hidden sm:inline"> of </span>
        {meta.last_page}
      </span>
      <Button variant="outline" disabled={page >= meta.last_page} onClick={() => onPage(page + 1)}>
        Next <ChevronRight className="size-4" />
      </Button>
    </div>
  )
}
